import { orderBy as deprecatedOrderBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetEditor';
import { FormatTypes, format } from '../../../../Lib/Format';
import { IconClose, IconRestore } from '../../../../Lib/Icons';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { Button, Dropdown, Field, Label } from '../../../Core';
import './FixedSnapshotHeader.scss';

/**
 * @deprecated Use ramda sortBy not lodash orderBy
 */
const sortBy = deprecatedOrderBy;

const getSnapshotCaption = (snapshot) =>
  snapshot.id.substr(0, 6) +
  ' - ' +
  snapshot.description +
  ' (' +
  format({
    type: FormatTypes.DateTime,
  })(snapshot.date) +
  ')';

const FixedSnapshotHeader = () => {
  const snapshotId = useSelector((state) => state.worksheetEditor.snapshotPreview?.id);
  const snapshotOptions = useSelector(
    (state) =>
      sortBy(Object.values(state.worksheetEditor.snapshots), (r) => r.date, ['desc']).map((s) => ({
        value: s.id,
        label: getSnapshotCaption(s),
      })),
    deepEquals
  );
  const dispatch = useDispatch();

  const worksheetLocked = useSelector((state) => state.worksheetEditor.status.readonly.locked);

  const applySnapshot = () => {
    dispatch(actions.addSnapshot({ description: `Auto: Before revert to ${snapshotId.substr(0, 6)}` }));
    dispatch(actions.applySnapshot({ id: snapshotId, sync: true }));
    dispatch(actions.setSnapshotPreviewId({ id: null }));
  };

  if (!snapshotId) return null;

  return (
    <header className="FixedSnapshotHeader">
      <div className="FixedSnapshotHeader-Content" id="fixed-snapshot-header">
        <div className="FixedSnapshotHeader-SnapshotSelection">
          <Label className="FixedSnapshotHeader-SnapshotSelectionLabel">Snapshot:</Label>
          <Field
            input={<Dropdown />}
            options={snapshotOptions}
            onChange={(e) => dispatch(actions.setSnapshotPreviewId({ id: e.data.value }))}
            value={snapshotId}
            simpleValue
            isClearable={false}
            alwaysEnabled={true}
            horizontal
          />
        </div>
        <div className="FixedSnapshotHeader-Buttons">
          <Button alwaysEnabled={!worksheetLocked} subtle primary onClick={applySnapshot}>
            <IconRestore />
            Revert to this snapshot
          </Button>
          <Button
            alwaysEnabled={true}
            subtle
            primary
            onClick={() => dispatch(actions.setSnapshotPreviewId({ id: null }))}
          >
            <IconClose />
            Close Preview
          </Button>
        </div>
      </div>
    </header>
  );
};

export { FixedSnapshotHeader };
export default FixedSnapshotHeader;
